document.addEventListener('DOMContentLoaded', () => {
    const $navbar = document.getElementById('navbar');
    const $menuElement = document.getElementById('mainmenu');
    const $navbarBurger = document.getElementById('navbar-burger');
    const $languageSelect = document.getElementById('language-select');
    const $langElements = document.querySelectorAll('.navbar-lang-toggle');

    function updateLanguageSelectPosition() {
        if ($languageSelect && $navbar) {
            const navbarHeight = $navbar.offsetHeight;
            if ($languageSelect.classList.contains('is-active')) {
                $languageSelect.style.opacity = 1;
                $languageSelect.style.transform = `translateY(${navbarHeight}px)`;
            } else {
                $languageSelect.style.opacity = 0;
                $languageSelect.style.transform = `translateX(100%) translateY(${navbarHeight}px)`;
            }
        }
    }

    if ($navbar) {
        const observer = new ResizeObserver(() => {
            updateLanguageSelectPosition();
        });
        observer.observe($navbar);
    }

    if ($languageSelect && $navbar) {
        const navbarHeight = $navbar.offsetHeight;
        $languageSelect.style.transform = `translateX(100%) translateY(${navbarHeight}px)`;
    }

    if ($languageSelect && $langElements) {
        Array.from($langElements).forEach(($el) => {
            $el.addEventListener('click', () => {
                $languageSelect.classList.toggle('is-active');
                document.documentElement.classList.toggle('has-lang-open');

                if ($languageSelect.classList.contains('is-active')) {
                    $el.classList.add('is-active');
                    if ($menuElement) $menuElement.classList.remove('is-active');
                    if ($navbarBurger) $navbarBurger.classList.remove('is-active');
                } else {
                    $el.classList.remove('is-active');
                }

                updateLanguageSelectPosition();
            });
        });

        document.addEventListener('click', (event) => {
            let isClickInside = false;

            if ($languageSelect.contains(event.target) || Array.from($langElements).some((element) => element.contains(event.target))) {
                isClickInside = true;
            }

            if (!isClickInside) {
                $languageSelect.classList.remove('is-active');
                document.documentElement.classList.remove('has-lang-open');

                Array.from($langElements).forEach(($el) => {
                    $el.classList.remove('is-active');
                });

                updateLanguageSelectPosition();
            }
        });
    }

    window.addEventListener('scroll', updateLanguageSelectPosition);
    window.addEventListener('resize', updateLanguageSelectPosition);
});
